import { Component, OnInit } from "@angular/core";
import {
	FormGroup,
	FormBuilder,
	Validators,
	FormControl
} from "@angular/forms";
import { Router } from "@angular/router";
import { AuthService } from "../../core/auth.service";

@Component({
	selector: "app-login",
	templateUrl: "./login.component.html",
	styleUrls: ["./login.component.scss"]
})
export class LoginComponent implements OnInit {
	readonly: boolean = true;
	form: FormGroup;
	loading: boolean = false;
	emptyResponse: boolean = false;

	constructor(
		private formBuilder: FormBuilder,
		private authService: AuthService,
		private router: Router
	) {}

	ngOnInit() {
		this.initForm();
	}
	initForm() {
		this.form = this.formBuilder.group({
			username: [null, [Validators.required]],
			password: [null, [Validators.required, Validators.minLength(8)]]
		});
	}
	validateFormFields(formGroup: FormGroup) {
		Object.keys(formGroup.controls).forEach(field => {
			const control = formGroup.get(field);
			control.markAsTouched({ onlySelf: true });
		});
	}
	isFieldValid(form: string, field: string) {
		return !this[form].get(field).valid && this[form].get(field).touched;
	}
	displayFieldCss(form: string, field: string) {
		return {
			error: this.isFieldValid(form, field)
		};
	}
	login() {
		if (this.form.valid) {
			this.loading = true;
			this.authService
				.login(this.form.value)
				.then(data => {
					this.loading = false;
					if (!data) {
						this.emptyResponse = true;
					} else {
						this.router.navigate(["/profile"]);
						console.log(
							"login service now working, you can go ahead"
						);
					}
				})
				.catch(err => {
					this.loading = false;
				});
		} else {
			this.validateFormFields(this.form);
		}
	}
}



// WEBPACK FOOTER //
// F:/Projects/anoki/src/app/pages/login/login.component.ts